export const MEDIUM_BUTTON_RADIUS: string = '6px 6px 6px 6px'
export const MEDIUM_BUTTON_BORDER_BOTTOM_DARK: string = '6px solid #bbbb02ff'
export const MEDIUM_BUTTON_BORDER_BOTTOM_LIGHT: string = '6px solid #ff10f0'
export const MEDIUM_BUTTON_BORDER_BOTTOM_SMALL_DARK: string =
  '4px solid #bbbb02ff'
export const MEDIUM_BUTTON_BORDER_BOTTOM_SMALL_LIGHT: string =
  '4px solid #ff10f0'
export const MEDIUM_BUTTON_BOX_SHADOW: string =
  '0 3px 6px rgba(255, 255, 255, 0.2), 0 2px 3px rgba(255, 255, 255, 0.15)'
export const MEDIUM_BUTTON_BOX_SHADOW_LIGHT: string =
  '0 5px 12px rgba(0, 0, 0, 0.15), 0 3px 3px rgba(0, 0, 0, 0.1)'
export const MEDIUM_BUTTON_SMALL_BOX_SHADOW: string =
  '0 2px 4px rgba(255, 255, 255, 0.2), 0 1.5px 2px rgba(255, 255, 255, 0.15)'
export const MEDIUM_BUTTON_SMALL_BOX_SHADOW_LIGHT: string =
  '0 5px 12px rgba(0, 0, 0, 0.15), 0 3px 3px rgba(0, 0, 0, 0.1)'
export const MEDIUM_BUTTON_DISABLED_BOX_SHADOW: string = 'initial'
export const MEDIUM_BUTTON_DISABLED_BORDER_BOTTOM: string = 'initial'
export const MEDIUM_BUTTON_DISABLED_BORDER_BOTTOM_LIGHT: string = 'initial'
export const MEDIUM_BUTTON_CLOSE_CANCEL_BOX_SHADOW_LIGHT: string =
  '0 5px 12px rgba(0, 0, 0, 0.15), 0 3px 3px rgba(0, 0, 0, 0.1)'
export const MEDIUM_BUTTON_CLOSE_CANCEL_BOX_SHADOW_DARK: string = 'initial'
export const MEDIUM_BUTTON_CLOSE_BORDER_BOTTOM: string =
  '6px solid rgba(7, 87, 161, 0.2)'
export const MEDIUM_BUTTON_CLOSE_BORDER_BOTTOM_LIGHT: string =
  '1.25px solid rgba(213, 237, 255, 1)'
export const MEDIUM_BUTTON_CLOSE_BORDER_RIGHT: string = 'initial'
export const MEDIUM_BUTTON_CLOSE_BORDER_TOP: string = '6px solid transparent'
export const MEDIUM_BUTTON_CLOSE_BORDER_TOP_LIGHT: string =
  '0.15px solid rgba(213, 237, 255, 1)'
export const MEDIUM_BUTTON_CLOSE_BORDER_LEFT: string = 'initial'
export const MEDIUM_BUTTON_CLOSE_BORDER_LEFT_LIGHT: string =
  '0.15px solid rgba(213, 237, 255, 1)'
export const MEDIUM_BUTTON_CLOSE_BORDER_RIGHT_LIGHT: string =
  '1.25px solid rgba(213, 237, 255, 1)'
export const MEDIUM_BUTTON_CLOSE_RADIUS: string = '6px 6px 6px 6px'
export const MEDIUM_BUTTON_DANGER_BOX_SHADOW: string = 'initial'
export const MEDIUM_BUTTON_DANGER_BORDER_BOTTOM: string =
  '6px solid rgba(53, 0, 0, 0.58)'
export const MEDIUM_BUTTON_DANGER_RADIUS: string = '6px 6px 6px 6px'
export const COVER_ART_GENRE_THUMB_BOX_SHADOW_DARK: string = 'initial'
export const COVER_ART_GENRE_THUMB_BOX_SHADOW_DARK_ALTERNATIVE: string =
  '0 7px 12px rgba(0, 0, 0, 0.95), 0 3px 3px rgba(0, 0, 0, 0.95)'
export const COVER_ART_GENRE_THUMB_BOX_SHADOW_LIGHT: string =
  '0 7px 12px rgba(0, 0, 0, 0.15), 0 3px 3px rgba(0, 0, 0, 0.1)'
export const FAVORITES_CARD_BOX_SHADOW_DARK: string = 'initial'
export const FAVORITES_CARD_BOX_SHADOW_LIGHT: string =
  '0 7px 12px rgba(0, 0, 0, 0.15), 0 3px 3px rgba(0, 0, 0, 0.1)'
export const PRESET_PLAYLIST_THUMB_BOX_SHADOW_DARK: string =
  '0 0 3px 3px rgba(123, 120, 120, 0.2), 0 0 3px 3px rgba(123, 120, 120, 0.2)'
export const PRESET_PLAYLIST_THUMB_BOX_SHADOW_LIGHT: string =
  '0 10px 24px rgba(0, 0, 0, 0.3), 0 6px 6px rgba(0, 0, 0, 0.2)'
export const HOME_SPLASH_IMAGE_BOX_SHADOW_DARK: string =
  '0 0 6px 6px rgba(123, 120, 120, 0.35), 0 0 6px 6px rgba(123, 120, 120, 0.35)'
export const HOME_SPLASH_IMAGE_BOX_SHADOW_LIGHT: string =
  '0 10px 24px rgba(0, 0, 0, 0.4), 0 12px 12px rgba(0, 0, 0, 0.3)'
export const HOME_SPLASH_SECTION_HEADER_BOX_SHADOW_DARK: string =
  '0 3px 6px rgba(123, 120, 120, 0.2), 0 3px 6px rgba(123, 120, 120, 0.15)'
export const HOME_SPLASH_SECTION_HEADER_BOX_SHADOW_LIGHT: string =
  '0 5px 12px rgba(0, 0, 0, 0.15), 0 3px 3px rgba(0, 0, 0, 0.1)'
export const HOME_SPLASH_GET_STARTED_BUTTON_SHADOW_DARK: string =
  '0 2px 4px rgba(255, 255, 255, 0.2), 0 1px 2px rgba(255, 255, 255, 0.15)'
export const HOME_SPLASH_GET_STARTED_BUTTON_SHADOW_LIGHT: string =
  '0 8px 24px rgba(0, 0, 0, 0.15), 0 4px 8px rgba(0, 0, 0, 0.1)'
export const HOME_SPLASH_GET_STARTED_BUTTON_BORDER_BOTTOM_DARK: string =
  '6px solid #F25325'
export const HOME_SPLASH_GET_STARTED_BUTTON_BORDER_BOTTOM_LIGHT: string =
  'initial'
export const HOME_SPLASH_GET_STARTED_BUTTON_BORDER_RADIUS_DARK: string =
  '8px 8px 8px 8px'
export const HOME_SPLASH_GET_STARTED_BUTTON_BORDER_RADIUS_LIGHT: string =
  '8px 8px 8px 8px'
export const SEARCH_ACTION_ICON_BORDER_BOTTOM_OR_RIGHT_DARK: string =
  '4.5px solid #bbbb02ff'
export const SEARCH_ACTION_ICON_BORDER_BOTTOM_OR_RIGHT_LIGHT: string = 'initial'
export const SEARCH_ACTION_ICON_BOX_SHADOW_DARK: string =
  '0 8px 24px rgba(255, 255, 255, 0.1), 0 4px 8px rgba(255, 255, 255, 0.05)'
export const SEARCH_ACTION_ICON_BOX_SHADOW_DARK_SMALL: string =
  '0 4px 8px rgba(255, 255, 255, 0.1), 0 4px 8px rgba(255, 255, 255, 0.05)'
export const SEARCH_ACTION_ICON_BOX_SHADOW_LIGHT: string =
  '0 8px 24px rgba(0, 0, 0, 0.15), 0 4px 8px rgba(0, 0, 0, 0.1)'
export const SEARCH_ACTION_ICON_BOX_SHADOW_DARK_SUBTLE: string =
  '0 8px 24px rgba(255, 255, 255, 0.1), 0 4px 8px rgba(255, 255, 255, 0.05)'
export const SEARCH_ACTION_ICON_BOX_SHADOW_SUBTLE_LIGHT: string =
  '0 8px 24px rgba(0, 0, 0, 0.15), 0 4px 8px rgba(0, 0, 0, 0.1)'
export const MEDIUM_BUTTON_BORDER_BOTTOM_PRACTICAL_POD: string = 'initial'
export const MEDIUM_BUTTON_BORDER_RIGHT_PRACTICAL_POD: string = 'initial'
export const MEDIUM_BUTTON_BORDER_TOP_PRACTICAL_POD: string = 'initial'
export const MEDIUM_BUTTON_BORDER_LEFT_PRACTICAL_POD: string = 'initial'
export const MEDIUM_BUTTON_BOX_SHADOW_PRACTICAL_POD: string = 'initial'
export const MEDIUM_BUTTON_RADIUS_PRACTICAL_POD: string = '8px 8px 8px 8px'
export const MEDIUM_BUTTON_DISABLED_BORDER_BOTTOM_PRACTICAL_POD: string =
  'initial'
export const MEDIUM_BUTTON_DISABLED_BOX_SHADOW_PRACTICAL_POD: string = 'initial'
export const MEDIUM_BUTTON_CLOSE_BORDER_BOTTOM_PRACTICAL_POD: string = 'initial'
export const MEDIUM_BUTTON_CLOSE_RADIUS_PRACTICAL_POD: string =
  '8px 8px 8px 8px'
export const MEDIUM_BUTTON_CLOSE_CANCEL_BOX_SHADOW_PRACTICAL_POD: string =
  'initial'
export const MEDIUM_BUTTON_DANGER_BOX_SHADOW_PRACTICAL_POD: string = 'initial'
export const MEDIUM_BUTTON_DANGER_BORDER_BOTTOM_PRACTICAL_POD: string =
  'initial'
export const MEDIUM_BUTTON_DANGER_RADIUS_PRACTICAL_POD: string =
  '8px 8px 8px 8px'
export const PRESET_PLAYLIST_THUMB_BOX_SHADOW_PRACTICAL_POD: string = 'initial'
export const FAVORITES_CARD_BOX_SHADOW_PRACTICAL_POD: string = 'initial'
export const COVER_ART_GENRE_THUMB_BOX_SHADOW_PRACTICAL_POD: string = 'initial'
export const HOME_SPLASH_GET_STARTED_BUTTON_SHADOW_PRACTICAL_POD: string =
  'initial'
export const HOME_SPLASH_GET_STARTED_BUTTON_BORDER_BOTTOM_PRACTICAL_POD: string =
  'initial'
export const HOME_SPLASH_GET_STARTED_BUTTON_BORDER_RADIUS_PRACTICAL_POD: string =
  '8px 8px 8px 8px'
export const HOME_SPLASH_IMAGE_BOX_SHADOW_PRACTICAL_POD: string = 'initial'
export const HOME_SPLASH_SECTION_HEADER_BOX_SHADOW_PRACTICAL_POD: string =
  'initial'
export const SEARCH_ACTION_ICON_BOX_SHADOW_PRACTICAL_POD: string = 'initial'
export const SEARCH_ACTION_ICON_BOX_SHADOW_SUBTLE_PRACTICAL_POD: string =
  'initial'
export const SEARCH_ACTION_ICON_BORDER_BOTTOM_OR_RIGHT_PRACTICAL_POD: string =
  'initial'
